import { render, staticRenderFns } from "./AutosizedCollapsibleFooter.vue?vue&type=template&id=46a6d5fa&scoped=true&"
import script from "./AutosizedCollapsibleFooter.vue?vue&type=script&lang=js&"
export * from "./AutosizedCollapsibleFooter.vue?vue&type=script&lang=js&"
import style0 from "./AutosizedCollapsibleFooter.vue?vue&type=style&index=0&id=46a6d5fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a6d5fa",
  null
  
)

export default component.exports